import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import { createInstitutionCorporateOwner, type InstitutionOwnershipOrDefaults } from '@/features/institution/ownership/schema';

const InstitutionOwnershipFieldsetHasCorporateOwners = () => {
  const form = useFormContext<InstitutionOwnershipOrDefaults>();
  const { t } = useTranslation();

  return (
    <FormField
      name="hasCorporateOwners"
      control={form.control}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('institutionDetails.ownership.hasCorporateOwners.title')}*</FormLabel>
          <FormControl>
            <RadioGroup
              defaultValue={field.value}
              variant="cards"
              aria-label={t('institutionDetails.ownership.hasCorporateOwners.title')}
              onValueChange={(value) => {
                field.onChange(value);

                if (value === 'YES' && !form.getValues('corporateOwners')?.length) {
                  form.setValue('corporateOwners', [createInstitutionCorporateOwner()]);
                }
              }}
            >
              {BINARY_ANSWERS.map((answer) => (
                <FormItem key={answer}>
                  <RadioGroupItemCard variant="outline">
                    <FormControl>
                      <RadioGroupItem value={answer} />
                    </FormControl>
                    <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                  </RadioGroupItemCard>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
InstitutionOwnershipFieldsetHasCorporateOwners.displayName = 'InstitutionOwnershipFieldsetHasCorporateOwners';

export { InstitutionOwnershipFieldsetHasCorporateOwners };
